var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Prop, Vue, Component } from "vue-property-decorator";
import ViewFileInfo from "~/components/common/view-file-info.vue";
var ViewRecoredFiles = /** @class */ (function (_super) {
    __extends(ViewRecoredFiles, _super);
    function ViewRecoredFiles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.panel = "picture";
        return _this;
    }
    Object.defineProperty(ViewRecoredFiles.prototype, "recored", {
        get: function () {
            return {
                picture: this.pictures,
                video: this.videos,
                audio: this.audios
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewRecoredFiles.prototype, "files", {
        get: function () {
            return this.recored[this.panel] || [];
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop()
    ], ViewRecoredFiles.prototype, "pictures", void 0);
    __decorate([
        Prop()
    ], ViewRecoredFiles.prototype, "videos", void 0);
    __decorate([
        Prop()
    ], ViewRecoredFiles.prototype, "audios", void 0);
    ViewRecoredFiles = __decorate([
        Component({
            components: {
                ViewFileInfo: ViewFileInfo
            }
        })
    ], ViewRecoredFiles);
    return ViewRecoredFiles;
}(Vue));
export default ViewRecoredFiles;
